import { GetAllHealthPlans } from 'domain/usecases/patient/get-all-health-plans'
import { HealthInsurancePlans } from 'domain/usecases/health-insurance/load-health-insurance-plans'

/**
 * Converte o retorno da rota REST `GET /patient/api/health-plans`
 * (`GetAllHealthPlans.Model`) para o shape `HealthInsurancePlans[]` consumido
 * hoje pelo formulário de pedido cirúrgico. O objetivo é substituir a query
 * GraphQL `GetHealthInsurances` sem alterar o funcionamento de plano/subplano.
 */
export const mapHealthPlansToInsurancePlans = (
  healthPlans?: GetAllHealthPlans.Model
): HealthInsurancePlans[] =>
  (healthPlans ?? []).map((healthPlan) => ({
    code: healthPlan.health_insurance_id,
    description: healthPlan.name,
    ansRegister: healthPlan.ans_register,
    healthCard: '',
    plans: (healthPlan.plans ?? []).map((plan) => ({
      code: plan.plan_id,
      description: plan.name,
      subPlan: (plan.sub_plans ?? []).map((subPlan) => ({
        code: subPlan.sub_plan_id,
        description: subPlan.name
      }))
    }))
  }))
